import { render, staticRenderFns } from "./detailAttributionRecord.vue?vue&type=template&id=8652d0f6&scoped=true&"
import script from "./detailAttributionRecord.vue?vue&type=script&lang=js&"
export * from "./detailAttributionRecord.vue?vue&type=script&lang=js&"
import style0 from "./detailAttributionRecord.vue?vue&type=style&index=0&id=8652d0f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8652d0f6",
  null
  
)

export default component.exports